<template>
  <div class="menu">
    <span v-if="$route.path !== '/user'">
      <Group />
    </span>
    <span v-else>
      <User />
    </span>
  </div>
</template>

<script>
import Group from '@/components/modules/DailyReport/MenuGroup'
import User from '@/components/modules/DailyReport/MenuUser'

export default {
  components: {
    Group,
    User
  }
}
</script>

<style scoped>
.menu {
  float: left;
  background: #fff;
  width: 255px;
  height: calc(100% - 48px);
  border-right: 1px solid #e5e5e5;
  overflow: auto;
  z-index: 6;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/Menu.vue